import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class SafeguardService implements CanActivate{
    constructor() {}

    canActivate(): boolean | Promise<boolean> {
      return true;
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/safeguard.service.ts